import { IAllTagsResult } from '@rhizome/pgtypes';
import { FilterAlt } from '@styled-icons/material';
import React, { useState } from 'react';
import styled from 'styled-components';
import { MobileTippy } from '../utils/components/MobileTippy';
import { DefaultButton } from './DefaultButton';

type TagDisplayProps = {
  tags: IAllTagsResult[];
  selectedTags: Set<string>;
  setSelectedTags: any;
  open: boolean;
};

function TagDisplay(props: TagDisplayProps) {
  const [open, setOpen] = useState(props.open as boolean);
  const [searchField, setSearchField] = useState('');

  const handleSearchFieldChange = (
    evt: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (evt.target !== null) setSearchField(evt.target.value);
  };

  return (
    <React.Fragment>
      <DefaultButton
        style={{ display: 'inline-block', verticalAlign: 'text-top' }}
        onClick={() => {
          setOpen(!open);
        }}
      >
        <MobileTippy
          placement="bottom"
          content={open ? 'close filters' : 'open filters'}
          arrow={false}
          offset={[0, 0]}
        >
          <FilterAlt height="20px" />
        </MobileTippy>
      </DefaultButton>
      {open ? (
        <TagMenu
          searchField={searchField}
          selectedTags={props.selectedTags}
          handleSearchFieldChange={handleSearchFieldChange}
          setSearchField={setSearchField}
          setSelectedTags={props.setSelectedTags}
          tags={props.tags}
        />
      ) : null}
    </React.Fragment>
  );
}

export const TagMenu = (props: {
  searchField: string;
  selectedTags: Set<string>;
  handleSearchFieldChange: any;
  setSearchField: any;
  setSelectedTags: any;
  tags: IAllTagsResult[];
}) => {
  const {
    searchField,
    selectedTags,
    handleSearchFieldChange,
    setSearchField,
    setSelectedTags,
    tags,
  } = props;

  const filteredTags = tags.filter((tag) => {
    // if the tag has no references, don't show it
    if (tag.count === 0) {
      return false;
    }
    if (tag?.tags?.toLowerCase().includes(searchField.toLowerCase())) {
      return true;
    }
  });

  const tagElements = filteredTags.map((tag, index) => {
    return (
      <TagButton
        key={index}
        selected={selectedTags.has(tag.tags || '')}
        onClick={() => {
          const newSet: Set<string> = new Set(selectedTags);
          if (!selectedTags.has(tag.tags || '')) {
            newSet.add(tag.tags || '');
          } else {
            newSet.delete(tag.tags || '');
          }
          setSelectedTags(newSet);
          setSearchField('');
        }}
      >
        {tag.tags}
      </TagButton>
    );
  });

  return (
    <TagDisplayMenu>
      <div
        style={{
          margin: '0vh 0vh 1vh 0vh',
          display: 'block',
        }}
      >
        <input
          name="username"
          value={searchField}
          onChange={handleSearchFieldChange}
          autoComplete="off"
          placeholder="search for a tag..."
          style={{
            marginRight: '7px',
          }}
        />
        {searchField === '' ? null : (
          <DefaultButton
            onClick={() => {
              setSearchField('');
            }}
          >
            x
          </DefaultButton>
        )}
        {props.selectedTags.size > 0 ? (
          <DefaultButton
            onClick={() => {
              props.setSelectedTags(new Set());
            }}
            style={{
              marginRight: '7px',
            }}
          >
            clear selected
          </DefaultButton>
        ) : null}
      </div>
      <TagsContainer>{tagElements}</TagsContainer>
    </TagDisplayMenu>
  );
};

const TagDisplayMenu = styled.div`
  /* margin-bottom: 15px; */
  border-radius: 0.2rem;
  padding: 1vw;
  margin-bottom: 10px;
  /* margin: 0vw 2vw 0vw 0vw; */
  background-color: ${(props) => props.theme.colors.main.light};
`;

const TagButton = styled.button<{ selected: boolean }>`
  border-radius: 0.2rem;
  font-size: 15px;
  margin: 2.5px 5px 5px 0px;
  padding: 5px;
  border: none;

  background-color: ${(props) =>
    props.selected
      ? props.theme.colors.main.dark
      : props.theme.colors.main.medium};
  color: black;
`;

const TagsContainer = styled.div`
  overflow-y: scroll;
  max-height: 200px;
  /* :hover{
        max-height:200px;
    } */
`;

export default TagDisplay;
